import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const PublicationsContainer = styled.div `
  margin-bottom: 12px;
`;
const PublicationsTitle = styled.h3 `
  font-size: 1.7em;
  margin-bottom: 30px;
  color: #22334a;
`;
const PublicationCard = styled.div `
  background: linear-gradient(120deg, #fffdf4 0%, #fff 100%);
  border: 2px solid #ffce3c;
  border-radius: 16px;
  padding: 24px 28px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(255,206,60,0.07);
`;
const PublicationTitle = styled.h4 `
  font-size: 1.25rem;
  font-weight: 700;
  color: #22334a;
  margin: 0 0 8px 0;
`;
const PublicationVenue = styled.p `
  font-size: 1.1rem;
  font-weight: 600;
  color: #22334a;
  opacity: 0.8;
  margin: 0 0 12px 0;
`;
const PublicationDesc = styled.p `
  font-size: 0.95rem;
  line-height: 1.5;
  color: #22334a;
  opacity: 0.85;
  margin: 0 0 16px 0;
`;
const PublicationLink = styled.a `
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0A66C2;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    text-decoration: underline;
  }
`;
const Publications = () => {
    return (_jsxs(PublicationsContainer, { children: [_jsx(PublicationsTitle, { children: "Publications" }), _jsxs(PublicationCard, { children: [_jsx(PublicationTitle, { children: "Vehicle Routing Problem Research" }), _jsx(PublicationVenue, { children: "IEEE ICITE 2017" }), _jsx(PublicationDesc, { children: "Explored heuristic and AI algorithms for solving complex routing problems." }), _jsx(PublicationLink, { href: "https://ieeexplore.ieee.org/abstract/document/8056881", target: "_blank", rel: "noopener noreferrer", children: "Read the Paper" })] })] }));
};
export default Publications;
